module.exports = __webpack_public_path__ + "media/images/icons/sun-558fb79908bcbcf7c480ff02180231eb.svg";